(function(angular) {
    'use strict';

    angular
        .module('display')
        .component('display', {
            bindings: { },
            templateUrl: '/display/views/display.html',
            controller: [
                '$stateParams',
                'aprgettext',
                'BrowserService',
                'DisplayService',
                'FacilityVisitRepository',
                'MultiDownloadModal',
                'toaster',
                'TransitionManager',
                'FacilitySettingsService',
                'LocalStorageRepository',
                Display
            ],
        });

    function Display(
        $stateParams,
        gettext,
        BrowserService,
        DisplayService,
        FacilityVisitRepository,
        MultiDownloadModal,
        toaster,
        TransitionManager,
        FacilitySettingsService,
        LocalStorageRepository
    ) {
        var vm = this;

        vm.currentVisitNoteIndex = null;
        vm.documentId = null;
        vm.disableInlinePdf = !BrowserService.supportsInlinePdf();
        vm.patient = null;
        vm.patientName = '';
        vm.multiVisit = {
            selectedList: [],
            sourceList: [],
            all: true,
            sortBy: 'Date',
            patientId: '',
            externalId: '',
        };
        vm.showAttestation = false;
        vm.userId = '';
        vm.HcIpConfig = null;

        vm.$onInit = $onInit;
        vm.backToSearch = backToSearch;
        vm.downloadVisit = downloadVisit;
        vm.formatDate = formatDate;
        vm.getVisit = getVisit;
        vm.multiVisitModal = multiVisitModal;
        vm.openAttestation = openAttestation;
        vm.selectNextNote = selectNextNote;
        vm.selectPreviousNote = selectPreviousNote;
        vm.selectVisitNote = selectVisitNote;

        var updateUsageMetricDto = {
            MetricTypeName: '170.315(e)(1) - View, Download, and Transmit to 3rd Party',
            MetricSubTypeName: 'Success',
            IncrementFactor: 1,
        };

        function $onInit() {
            FacilitySettingsService.getHarmonyCaresIP().then(function(harmonyCaresIP) {
                vm.HcIpConfig = harmonyCaresIP;
                vm.showAttestation = harmonyCaresIP.IsLicensed;
            });

            if($stateParams.patientSearchResult) {
                vm.patient = $stateParams.patientSearchResult.patient;
            }
            if(vm.patient) {
                vm.patientName = vm.patient.FirstName + ' ' + vm.patient.LastName.substring(0, vm.patient.LastName.length - 2);
                vm.documentId = vm.patient.VisitId;
            }
            
            loadVisits();
        }

        // called when user clicks search button
        function backToSearch() {
            TransitionManager.transition({ appRoute: 'home'});
        }

        function multiVisitModal() {
            vm.multiVisit.sourceList = vm.visitNoteList;
            vm.multiVisit.patientId = vm.patient.PatientId;
            vm.multiVisit.externalId = vm.patient.ExternalId;

            MultiDownloadModal.openMultiModal(vm.multiVisit)
                .then(function(result) {
                    if(result === 'error') {
                        toaster.pop('error', '', gettext('An error occurred while downloading visit.  Please try again or contact your practice for further assistance.'));
                    }
                    if(result === 'success') {
                        toaster.pop('success', '', gettext('Download successful. Please check your downloads folder for your file.'));
                    }
            });
        }

        function openAttestation(){
            var url = vm.HcIpConfig.Url;

            if (url) {
                window.open(url + '?patientId=' + vm.patient.PatientId + '&currentUserId=' + LocalStorageRepository.getUserID() +'&origin=facilityPortal'+'&visitid=' + vm.documentId, '_blank');
              } else {
                  console.error('URL is undefined');
              }
        }

        function downloadVisit(documentId) {
            var usageMetricSubTypeName = 'Success';
            return FacilityVisitRepository.getPdfByVisit(vm.patient.PatientId, documentId)
                .catch(function(){
                    usageMetricSubTypeName = 'Failure';
                    toaster.pop('error', '', gettext('An error occurred while downloading visit.  Please try again or contact your practice for further assistance.'));
                })
                .finally(function() {
                    updateUsageMetric(usageMetricSubTypeName);
                });                
        }

        function formatDate(date) {
            return date.format('YYYY-MM-DD');
        }

        function getNextNoteIndex() {
            if (!vm.visitNoteList || !vm.visitNoteList.length) {
                return null;
            }
            if (!vm.currentVisitNoteIndex && vm.currentVisitNoteIndex !== 0) {
                return null;
            }
            return vm.currentVisitNoteIndex + 1;
        }

        function getPreviousNoteIndex() {
            if (!vm.visitNoteList || !vm.visitNoteList.length) {
                return null;
            }
            if (!vm.currentVisitNoteIndex && vm.currentVisitNoteIndex !== 0) {
                return null;
            }
            return vm.currentVisitNoteIndex - 1;
        }

        function getVisit(documentId) {
            return FacilityVisitRepository.getPdfByVisit(vm.patient.PatientId, documentId);
        }

        function loadVisits() {
            var usageMetricSubTypeName = 'Success';
            DisplayService.getOrderedVisitNoteList(vm.patient.PatientId).then(function(orderedVisitNoteList) {
                if(orderedVisitNoteList.success) {
                    vm.visitNoteList = orderedVisitNoteList.data; // ordered by visit date, lease recent to most

                    vm.currentVisitNoteIndex = null;
                    if(vm.visitNoteList && vm.visitNoteList.length) {
                        for(var i = 0; i < vm.visitNoteList.length; i++) {
                            if (vm.visitNoteList[i].VisitId === vm.documentId) {
                                vm.currentVisitNoteIndex = i;
                                break;
                            }
                        }
                    }
                } else {
                    usageMetricSubTypeName = 'Failure';
                    toaster.pop('error', '', 'Failed to get Notes');
                }

                updateUsageMetric(usageMetricSubTypeName);
            });
        }

        function selectNextNote() {
            var nextIndex = getNextNoteIndex();
            if(nextIndex !== null && nextIndex < vm.visitNoteList.length) {
                selectVisitNote(nextIndex);
            } else {
                toaster.warning('This is the last note');
            }
        }

        function selectPreviousNote() {
            var previousIndex = getPreviousNoteIndex();
            if(previousIndex !== null && previousIndex >= 0) {
                selectVisitNote(previousIndex);
            } else {
                toaster.warning('This is the first note');
            }
        }

        // change current visit note to specified index and display
        function selectVisitNote(index) {
            var visit = vm.visitNoteList[index];
            if (visit) {
                vm.documentId = visit.VisitId;
                vm.currentVisitNoteIndex = index;
            }
        }

        function updateUsageMetric(metricSubTypeName) {
            updateUsageMetricDto.MetricSubTypeName = metricSubTypeName;
            FacilityVisitRepository.postUsageMetricUpdate(updateUsageMetricDto);
        }
    }
})(window.angular);
